/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlUserJoinClientRequestStatus } from './ControlUserJoinClientRequestStatus';
import {
    ControlUserJoinClientRequestStatusFromJSON,
    ControlUserJoinClientRequestStatusFromJSONTyped,
    ControlUserJoinClientRequestStatusToJSON,
} from './ControlUserJoinClientRequestStatus';

/**
 * 
 * @export
 * @interface ControlUpgradeRequestRequest
 */
export interface ControlUpgradeRequestRequest {
    /**
     * 
     * @type {ControlUserJoinClientRequestStatus}
     * @memberof ControlUpgradeRequestRequest
     */
    request_status: ControlUserJoinClientRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlUpgradeRequestRequest
     */
    created: string;
}

/**
 * Check if a given object implements the ControlUpgradeRequestRequest interface.
 */
export function instanceOfControlUpgradeRequestRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "request_status" in value;
    isInstance = isInstance && "created" in value;

    return isInstance;
}

export function ControlUpgradeRequestRequestFromJSON(json: any): ControlUpgradeRequestRequest {
    return ControlUpgradeRequestRequestFromJSONTyped(json, false);
}

export function ControlUpgradeRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUpgradeRequestRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'request_status': ControlUserJoinClientRequestStatusFromJSON(json['request_status']),
        'created': json['created'],
    };
}

export function ControlUpgradeRequestRequestToJSON(value?: ControlUpgradeRequestRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request_status': ControlUserJoinClientRequestStatusToJSON(value.request_status),
        'created': value.created,
    };
}

